import Rellax from 'rellax'

var rellax = new Rellax('.paralax');
